import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import * as FaIcons from "react-icons/fa";

const EmailLoggerCard = ({
  info: {
    _id,
    createdAt,
    fromEmail,
    recipientEmail,
    emailType,
    relatedRecordId,
    learningCenterName,
    status,
    errorMessage,
  },
}) => {
  const formatEmails = (emails) => {
    if (!emails || emails.length === 0) return "N/A";
    if (Array.isArray(emails)) {
      return emails.join(", ");
    }
    return emails;
  };

  const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case 'sent':
        return { color: '#537131', fontWeight: '600' };
      case 'failed':
        return { color: '#dc3545', fontWeight: '600' };
      case 'pending':
        return { color: '#ffc107', fontWeight: '600' };
      default:
        return { color: '#6c757d', fontWeight: '600' };
    }
  };

  return (
    <Link to={`/email-logger/${_id}`} className="interest-form-card">
      <div className="top">
        <div className="left">
          <div className="name">
            <h2 style={{ fontSize: '14px' }}>{emailType || "Email"}</h2>
          </div>
          <FaIcons.FaEnvelope className="form-card-icon" />
        </div>
        <div className="right">
          <h3 style={getStatusStyle(status)}>{status || "N/A"}</h3>
        </div>
      </div>
      <div className="body">
        <div className="item">
          <h4>Submit Date: </h4>
          <p>{moment(createdAt).format("MM/DD/YYYY")}</p>
        </div>
        <div className="item">
          <h4>Site: </h4>
          <p>{learningCenterName}</p>
        </div>
        <div className="item">
          <h4>From Email: </h4>
          <p>{fromEmail || "N/A"}</p>
        </div>
        <div className="item">
          <h4>To Email: </h4>
          <p title={formatEmails(recipientEmail)}>{formatEmails(recipientEmail)}</p>
        </div>
        <div className="item">
          <h4>Email Type: </h4>
          <p>{emailType || "N/A"}</p>
        </div>
        <div className="item">
          <h4>Related Record Id: </h4>
          <p>{relatedRecordId || "N/A"}</p>
        </div>
        {errorMessage && (
          <div className="item">
            <h4>Error: </h4>
            <p style={{ color: '#dc3545' }}>{errorMessage}</p>
          </div>
        )}
      </div>
    </Link>
  );
};

export default EmailLoggerCard;
